// eslint-disable @typescript-eslint/ban-ts-comment
// @ts-ignore

import React, { useState, useRef, useCallback, useEffect } from "react";
import CardLayout from "react-lib/apps/common/CardLayout";
import ModEditDocument from "react-lib/apps/common/ModEditDocument";
import PatientIdentification from "react-lib/apps/common/PatientIdentification";
import PatientSearchBox from "react-lib/apps/common/PatientSearchBox";
import SearchBox from "react-lib/apps/common/SearchBox";
import ComboBox from "react-lib/apps/common/ComboBox";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import DateTextBox from "react-lib/apps/common/DateTextBox";
import ModInfo from "react-lib/apps/common/ModInfo";
import ModAuthen from "react-lib/apps/common/ModAuthen";

import {
  Container,
  Grid,
  Segment,
  Form,
  Button,
  Input,
  Checkbox,
  TextArea,
} from "semantic-ui-react";

import Viewer from "react-viewer";
import { PDFDocument, degrees } from "pdf-lib";
import axios from "axios";

import PureReactTable, { alignCenter } from "react-lib/apps/common/PureReactTable";
import { printPDFFixedSecurity } from "react-lib/utils/printURL";
import { useIntl } from "react-intl";
import { adToBeWithSetFormat } from "react-lib/utils/dateUtils";
import { base64toBlob } from "./CommonInterface";
// import Zoom from "../../../_qmljs/Common/Zoom";

interface CardScannedDocumentProps {
  django?: Record<string, any>;
  selectedEncounter?: Record<string, any>;
  patientData?: Record<string, any>;
  patientInfo?: Record<string, any>;
  controller?: Record<string, any>;
  readOnly?: boolean;
  onClose?: () => void;
  closeable?: boolean;
  toggleable?: boolean;
  hideFilter?: boolean;
  filterByIds?: any[];
  isViewDocumant?: boolean;
  documentCategoryId?: number | string;
  isViewDocument?: boolean;
  isGrouped?: boolean;
  isLoading?: boolean;
  languageUX?: string;
}

const FrameChrome = ({ file }: { file: string }) => {
  if (!file) {
    return null;
  }

  const frame = `<iframe src="${file}" width="100%" height="100%"></iframe>`;

  return (
    <div dangerouslySetInnerHTML={{ __html: frame }} style={{ height: "100%", width: "100%" }} />
  );
};

const DEFAULT_PROPS = {
  selectedEncounter: {
    number: null,
    queue_date: "",
  },
  patientData: {},
  patientInfo: {
    hn: "",
    encounter_id: "",
    id: "",
  },
  controller: {},
  readOnly: true,
  django: {},
  onClose: () => {},
  closeable: true,
  toggleable: false,
  hideFilter: false,
  isViewDocumant: false,
  isGrouped: false,
};

const CardScannedDocument = React.forwardRef<any, CardScannedDocumentProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };
  const intl = useIntl();
  const isMounted = useRef(false);

  const [nationalitiesChoices, setNationalitiesChoices] = useState<any[]>([]);
  const [currentHNPage, setCurrentHNPage] = useState(1);
  const [numberOfHNPage, setNumberOfHNPage] = useState(1);
  const [patientList, setPatientList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [image, setImage] = useState("");

  const [scannedDocList, setScannedDocList] = useState<any[]>([]);

  const [searchBoxOptions, setSearchBoxOptions] = useState<any[]>([]);
  const [defaultSearchBoxId, setDefaultSearchBoxId] = useState(null);
  const [defaultSearchBoxText, setDefaultSearchBoxText] = useState("");
  const [documentCategoryOptions, setDocumentCategoryOptions] = useState<any[]>([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState<any[]>([]);
  const [divisionOptions, setDivisionOptions] = useState<any[]>([]);

  const [docNumber, setDocNumber] = useState("");
  const [startDoc, setStartDoc] = useState("");
  const [endDoc, setEndDoc] = useState("");
  const [startScan, setStartScan] = useState("");
  const [endScan, setEndScan] = useState("");
  const [startExp, setStartExp] = useState("");
  const [endExp, setEndExp] = useState("");

  const [checkedAll, setCheckedAll] = useState(false);

  const [scannedDocLimit, setScannedDocLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [numberOfPage, setNumberOfPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);

  const [openModSecretAuthen, setOpenModSecretAuthen] = useState(false);
  const [openModInfoSuccess, setOpenModInfoSuccess] = useState(false);
  const [openModEditDoc, setOpenModEditDoc] = useState(false);
  const [openModCancelAuthen, setOpenModCancelAuthen] = useState(false);

  const [cancelDocError, setCancelDocError] = useState(null);
  const [editDocError, setEditDocError] = useState(null);
  const [cancelNote, setCancelNote] = useState("");

  const [cboLoading, setCboLoading] = useState(false);
  const [pdfBlob, setPdfBlob] = useState("");

  const hnRef = useRef();
  const enRef = useRef();
  const docCategoryRef = useRef();
  const docTypeRef = useRef();
  const ownerDivRef = useRef();
  const scanDivRef = useRef();
  const scanUserRef = useRef();
  const doctorRef = useRef();
  const modSecretAuthenRef = useRef();
  // const zoomRef = useRef();
  const modEditDocRef = useRef();

  const generateDocumentImage = useCallback(async (selectedRow) => {
    if (!selectedRow || !selectedRow.items || selectedRow.items.length === 0) {
      return "";
    }

    const pdfDoc = await PDFDocument.create();

    try {
      const fetchImages = selectedRow.items.map((item) =>
        axios.get(item.document_image, { responseType: "arraybuffer" }).then((res) => ({
          data: res.data,
          item,
        }))
      );
      const imageResponses = ((await Promise.all(fetchImages)))
      console.log('imageResponses: ', imageResponses);

      for (const { data, item } of imageResponses) {
        try {
          const jpgImage = await pdfDoc.embedJpg(data);
          const jpgDims = jpgImage.scale(0.5);
          const page = pdfDoc.addPage([jpgDims.width, jpgDims.height]);
          page.drawImage(jpgImage, {
            x: 0,
            y: 0,
            width: jpgDims.width,
            height: jpgDims.height,
            opacity: 1,
            rotate: degrees(0),
          });
        } catch (error) {
          console.error(`Failed to process image ${item.document_image}:`, error);
        }
      }

      return await pdfDoc.saveAsBase64({ dataUri: true });
    } catch (error) {
      console.error("Error generating PDF:", error);
      return "";
    }
  }, []);

  const handleSetDocumentImage = useCallback(async (selectedRow: any) => {
    const pdf = await generateDocumentImage(selectedRow);
    // console.log('generateDocumentImage: pdf :', pdf);

    const blob = pdf ? URL.createObjectURL(base64toBlob(pdf)) : "";

    setPdfBlob(blob);
  }, []);

  useEffect(() => {
    //! MUST not be move below CDM UNLESS calling the func at the first render is desired
    //! Currently, it will be called only if users change the page limit
    //! The encounterId is not yet ready at the first render, after encounterId is fetch,
    //! handleSearchDocument() will be called by the another React.useEffect below
    if (isMounted.current) {
      if (currentPage === 0) {
        handleSearchDocument();
      } else {
        setCurrentPage(0);
      }
    }
  }, [scannedDocLimit]);

  useEffect(() => {
    if (isMounted.current) {
      handleSearchDocument();
    }
  }, [currentPage, props.filterByIds]);

  useEffect(() => {
    //! ALL React.useEffect above this func are expected to not be called during the first render
    //* ComponentDidMount -- All func declare here is expected to be called only once,
    //*                      If it is called more than once, please move it out of useEffect

    //! set isMounted.current here since some useEffect are not expected to function at the first render
    isMounted.current = true;

    const getDocumentCategory = async () => {
      setCboLoading(true);
      const [data, error] = await props.controller.getDocumentCategory({
        limit: "99999",
        division: "all",
      });
      if (isMounted.current) {
        setCboLoading(false);
        if (data) {
          setDocumentCategoryOptions(data);
        } else {
          setDocumentCategoryOptions([]);
        }
      }
    };

    const getDivision = async () => {
      setCboLoading(true);
      const [data, error] = await props.controller.getDivision({
        limit: "99999",
      });
      if (isMounted.current) {
        setCboLoading(false);
        if (data) {
          setDivisionOptions(data);
        } else {
          setDivisionOptions([]);
        }
      }
    };

    getDocumentCategory();
    getDivision();

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    //! will get new Scanned Doc every time encounterId change
    const defaultGetScannedDoc = async () => {
      if (props.patientInfo?.encounter_id) {
        await defaultGetEncounter();
        if (!isMounted.current) {
          return;
        }
        handleSearchDocument();
      } else {
        handleSearchDocument();
      }
    };

    defaultGetScannedDoc();
  }, [props.patientInfo]);

  useEffect(() => {
    const checkSecretAll = () => {
      let arr = scannedDocList.filter((item: any) => item.is_secret);
      if (arr.length === scannedDocList.length && scannedDocList.length > 0) {
        setCheckedAll(true);
      } else {
        setCheckedAll(false);
      }
    };
    checkSecretAll();
  }, [scannedDocList]);

  useEffect(() => {
    setCancelDocError(null);
    setEditDocError(null);
  }, [openModEditDoc]);

  useEffect(() => {
    handleSetDocumentImage(selectedRow);
  }, [selectedRow]);

  useEffect(() => {
    getDocumentType({ category: props.documentCategoryId });
  }, [props.documentCategoryId]);

  const getDocumentType = async ({ category, name }: any = {}) => {
    (docTypeRef as any).current.clear();
    setCboLoading(true);
    const [data, error] = await props.controller.getDocumentType({
      limit: "99999",
      category,
      name,
    });
    if (isMounted.current) {
      setCboLoading(false);
      if (data) {
        setDocumentTypeOptions(data);
      } else {
        setDocumentTypeOptions([]);
      }
    }
    return [data, error];
  };

  const getNationality = async () => {
    const [data, error] = await props.controller.getNationalities();
    if (isMounted.current) {
      if (data) {
        setNationalitiesChoices(data);
      } else {
        setNationalitiesChoices([]);
      }
    }
  };

  const getPatientList = async ({
    hn,
    fullName,
    citizenId,
    nationality,
    patientCurrentPage,
  }: any = {}) => {
    let limit = 40;
    let page = patientCurrentPage ? patientCurrentPage : currentHNPage;
    setIsLoading(true);
    setCurrentHNPage(page);
    const [data, error] = await props.controller.getSearchAllPatient({
      hn,
      fullName,
      citizenId,
      nationality,
      is_old_name_search: true,
      limit,
      offset: (page - 1) * limit,
    });
    if (isMounted.current) {
      setIsLoading(false);
      if (data) {
        setPatientList(data.items);
        setNumberOfHNPage(parseInt(data.total) / limit + 1);
      } else {
        setPatientList([]);
        setNumberOfHNPage(1);
      }
    }
    return [data, error];
  };

  const handlePaginationChange = async ({
    hn,
    fullName,
    citizenId,
    nationality,
    patientCurrentPage,
  }: any = {}) => {
    setCurrentHNPage(patientCurrentPage);
    getPatientList({
      hn,
      fullName,
      citizenId,
      nationality,
      patientCurrentPage,
    });
  };

  const defaultGetEncounter = async () => {
    const [data, error] = await getEncounterSearch({
      encounterId: props.patientInfo?.encounter_id,
    } as any);
    if (isMounted.current) {
      if (data) {
        setSearchBoxOptions(data);
        setDefaultSearchBoxId(data[0].id);
        setDefaultSearchBoxText(data[0].number_date);
      }
    }
    return [data, error];
  };

  const getEncounterSearch = async ({ searchText, encounterId }: any = {}) => {
    let hnInput;
    let patientId;

    if (hnRef && hnRef.current) {
      hnInput = (hnRef as any).current.value();
      patientId = (hnRef as any).current.getPatientId();
      if (hnInput === props.patientInfo?.hn) {
        patientId = props.patientInfo.id;
      }

      const [data, error] = await props.controller.getEncounterSearch({
        search: searchText,
        encounterId,
        patientId,
      });

      if (!error) {
        return [data.items, error];
      } else {
        return [null, error];
      }
    } else {
      return [null, "hnRef are null"];
    }
  };

  const getUsersSearch = async ({ searchText }: any = {}) => {
    const [data, error] = await props.controller.getUsers({
      fullName: searchText,
    });
    return [data, error];
  };

  const getDoctorSearch = async ({ searchText }: any = {}) => {
    const [data, error] = await props.controller.getDoctor({
      search: searchText,
    });
    return [data, error];
  };

  const handleSearchDocument = async () => {
    setError(null);
    setIsLoading(true);

    let patientHn = null;
    let encounterId = null;
    let documentType = null;
    let scanDivision = null;
    let scanUser = null;
    let ownerDivision = null;
    let encounterDoctor = null;

    if (hnRef && hnRef.current) {
      patientHn = (hnRef as any).current.value();
    }
    if (enRef && enRef.current) {
      encounterId = (enRef as any).current.getId();
    }

    if (docTypeRef && docTypeRef.current) {
      documentType = (docTypeRef as any).current.getValue();
    }

    if (scanDivRef && scanDivRef.current) {
      scanDivision = (scanDivRef as any).current.getValue();
    }

    if (scanUserRef && scanUserRef.current) {
      scanUser = (scanUserRef as any).current.getId();
    }

    if (ownerDivRef && ownerDivRef.current) {
      ownerDivision = (ownerDivRef as any).current.getValue();
    }

    if (doctorRef && doctorRef.current) {
      encounterDoctor = (doctorRef as any).current.getId();
    }

    const api = props.isGrouped
      ? props.controller.getScannedDocumentByGroup
      : props.controller.getScannedDocument;

    const [data, error] = await api({
      patientHn: patientHn,
      encounterId: encounterId,
      documentType: documentType,
      documentNo: docNumber,
      scanDivision: scanDivision,
      scanUser: scanUser,
      ownerDivision: ownerDivision,
      encounterDoctor: encounterDoctor,
      docFromDate: startDoc,
      docToDate: endDoc,
      scanFromDate: startScan,
      scanToDate: endScan,
      expiryFromDate: startExp,
      expiryToDate: endExp,
      limit: scannedDocLimit,
      offset: scannedDocLimit * currentPage,
      idList: props.filterByIds,
    });
    if (isMounted.current) {
      setIsLoading(false);
      if (data) {
        setNumberOfPage(parseInt(data.total) / scannedDocLimit);
        setScannedDocList(data.items.map((item, index) => ({ ...item, id: item.id || index + 1 })));
      } else {
        setError(error);
        setScannedDocList([]);
      }
    }
  };

  const handleUpdateSecret = async ({ username, password }: any = {}) => {
    setIsLoading(true);
    setError(null);

    const items = props.isGrouped
      ? scannedDocList.flatMap((item) =>
          item.items.map((acc: any) => ({ ...acc, is_secret: item.is_secret ?? false }))
        )
      : scannedDocList;

    const [data, error] = await props.controller.putScannedDocUpdateSecret({
      username,
      password,
      items,
    });
    if (isMounted.current) {
      if (error) {
        setError(error);
      } else {
        setOpenModSecretAuthen(false);
        (modSecretAuthenRef as any).current.clear();
        setOpenModInfoSuccess(true);
        handleSearchDocument();
      }
      setIsLoading(false);
    }
    return [data, error];
  };

  const handleCancelDocument = async ({ username, password, cancelNote, scanDocId }: any = {}) => {
    setIsLoading(true);
    setCancelDocError(null);

    const items = props.isGrouped ? selectedRow?.items || [] : [{ id: scanDocId }];

    const promiseArr = items.map((item: any) =>
      props.controller.patchScannedDocument({
        username,
        password,
        cancelNote,
        scanDocId: item.id,
        active: false,
      })
    );

    const response = await Promise.all(promiseArr);
    const success = response.every((item: any) => item[1] === null);

    let result = [null, null];

    if (!success) {
      response.forEach((res: any) => {
        if (res[1]) {
          result[0] = res[0];
          result[1] = res[1];
        }
      });
    } else {
      setOpenModCancelAuthen(false);
    }

    if (isMounted.current) {
      if (result[1]) {
        setCancelDocError(result[1]);
      } else {
        setOpenModEditDoc(false);
        handleSearchDocument();
      }
      setIsLoading(false);
    }

    return [result[0], result[1]];
  };

  const handleEditDocument = async ({
    username,
    password,
    scanDocId,
    documentType,
    documentNo,
    version,
    ownerDivision,
    documentDate,
    expiryDate,
    remark,
  }: any = {}) => {
    setIsLoading(true);
    setEditDocError(null);

    const items = props.isGrouped ? selectedRow?.items || [] : [{ id: scanDocId }];

    const promiseArr = items.map((item: any) =>
      props.controller.patchScannedDocument({
        username,
        password,
        scanDocId: item.id,
        documentType,
        documentNo,
        version,
        ownerDivision,
        documentDate,
        expiryDate,
        remark,
      })
    );

    const response = await Promise.all(promiseArr);
    const success = response.every((item: any) => item[1] === null);

    let result = [null, null];

    if (!success) {
      response.forEach((res: any) => {
        if (res[1]) {
          result[0] = res[0];
          result[1] = res[1];
        }
      });
    }

    if (isMounted.current) {
      if (result[1]) {
        setEditDocError(result[1]);
      } else {
        setOpenModEditDoc(false);
        handleSearchDocument();
      }
      setIsLoading(false);
    }

    return [result[0], result[1]];
  };

  const generatePagination = () => {
    let btnArr: any[] = [];
    for (let i = 0; i < numberOfPage; i++) {
      let color = null;
      if (currentPage === i) {
        color = "blue";
      }
      btnArr.push(
        <Button
          onClick={() => setCurrentPage(i)}
          key={"btnPage" + i}
          testid={"btnPage" + i}
          icon
          content={i + 1}
          color={color as any}
        />
      );
    }
    return btnArr;
  };

  const handleCheckedAll = (e: any, { checked }: any) => {
    let newArr = [...scannedDocList];
    for (let item of newArr) {
      if (checked) {
        (item as any).is_secret = true;
      } else {
        (item as any).is_secret = false;
      }
    }
    setScannedDocList(newArr);
  };

  const handleCheckIsSecret = ({ row, checked }: any = {}) => {
    let index = scannedDocList.findIndex((item: any) => item.id === row.original.id);
    let newArr = [...scannedDocList];
    (newArr[index] as any).is_secret = checked;
    setScannedDocList(newArr);
  };

  const handlePreparePrintURL = async (original: any) => {
    if (props.isGrouped) {
      const pdf = await generateDocumentImage(original);
      // console.log('handlePreparePrintURL pdf: ', pdf);
      if (pdf.startsWith('data:application/pdf;base64,')) {
        printPDFFixedSecurity(pdf)
      } else {
        printPDFFixedSecurity(`data:application/pdf;base64,${pdf}`)
      }
    } else {
      
      // console.log('original.document_image: ', original.document_image);
      printPDFFixedSecurity(original.document_image);
    }
  };

  console.log("CardScannedDocument props:", props);
  return (
    <div className="--override-disabled --grey">
      <CardLayout
        closeable={props.closeable}
        toggleable={props.toggleable}
        titleText="Scanned Documents"
        headerColor="blue"
        loading={isLoading}
        onClose={props.onClose}
        dimmerStyle={{ ...(props.isViewDocumant && { visibility: "hidden" }) }}
      >
        <ModInfo
          titleColor="green"
          titleName="บันทึกสำเร็จ"
          btnText="ตกลง"
          open={openModInfoSuccess}
          onApprove={() => setOpenModInfoSuccess(false)}
        />
        <ModAuthen
          ref={modSecretAuthenRef}
          open={openModSecretAuthen}
          titleName="ปกปิดเอกสาร"
          approveButtonText="ตกลง"
          denyButtonText="ปิด"
          onApprove={handleUpdateSecret}
          onCloseWithDimmerClick={() => {
            setOpenModSecretAuthen(false);
            (modSecretAuthenRef as any).current.clear();
          }}
          onDeny={() => {
            setOpenModSecretAuthen(false);
            (modSecretAuthenRef as any).current.clear();
          }}
          loading={isLoading}
          error={error}
        />
        {/* <Zoom ref={zoomRef as any} /> */}
        <ModEditDocument
          ref={modEditDocRef}
          open={openModEditDoc}
          onClose={() => setOpenModEditDoc(false)}
          data={selectedRow}
          onGetDocumentTypeOptions={({ searchText }: any = {}) =>
            getDocumentType({ name: searchText })
          }
          divisionOptions={divisionOptions}
          onCancelApprove={handleCancelDocument}
          onEditApprove={handleEditDocument}
          cancelDocError={cancelDocError}
          editDocError={editDocError}
          loading={isLoading}
        />
        <ModAuthen
          testid="modCancelAuthen"
          open={openModCancelAuthen}
          approveButtonText="ตกลง"
          denyButtonText="ปิด"
          titleColor="red"
          titleName="ยกเลิกเอกสาร"
          onDeny={() => setOpenModCancelAuthen(false)}
          error={cancelDocError}
          onCloseWithDimmerClick={() => setOpenModCancelAuthen(false)}
          onApprove={({ username, password }: any = {}) =>
            handleCancelDocument({ username, password, cancelNote, selectedRow })
          }
        >
          <Form.Field label="เหตุผลในการยกเลิก" error={props.cancelDocError ? true : false} />
          <Form.Field error={props.cancelDocError ? true : false}>
            <TextArea value={cancelNote} onChange={(e) => setCancelNote(e.target.value)} />
          </Form.Field>
        </ModAuthen>
        <div style={{ ...(props.isViewDocumant && { visibility: "visible", marginTop: "-60px" }) }}>
          <ErrorMessage error={error} />
          <PatientIdentification patientInfo={props.patientInfo} />
          <Container fluid>
            <Grid columns={2}>
              <Grid.Column>
                <Segment id="container" color="grey" inverted style={styles.segment}>
                  {/* <img
                // @ts-ignore
                testid="imgScanned"
                style={styles.image}
                src={image}
                onClick={(e) => {
                  // (zoomRef as any).current.qml.show(image, e);
                }}
              /> */}
                  {props.isGrouped ? (
                    <FrameChrome file={pdfBlob} />
                  ) : (
                    <Viewer
                      visible={!!image}
                      onClose={() => {
                        setSelectedRow(null);
                        setImage("");
                      }}
                      // activeIndex={this.state.imgActiveIndex}
                      images={[{ src: image }]}
                      container={document.getElementById("container")}
                    />
                  )}
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Form>
                  {props.isViewDocumant && (
                    <Form.Group>
                      <Form.Field width={3}>
                        <label>EN/AN</label>
                        <Input disabled value={props.selectedEncounter?.number}></Input>
                      </Form.Field>
                      <Form.Field width={4}>
                        <label>วันที่รับบริการ</label>
                        <DateTextBox
                          disabled
                          value={adToBeWithSetFormat(props.selectedEncounter?.queue_date)}
                        />
                      </Form.Field>
                      <Form.Field width={10}>
                        <label>{intl.formatMessage({ id: "ชื่อเอกสาร" })}</label>
                        <ComboBox
                          id="ScannedDocument-ComboBox-DocType"
                          testid="cboDocType"
                          ref={docTypeRef}
                          fluid
                          clearable
                          placeholder="แสดงทุกประเภท"
                          options={documentTypeOptions}
                          loading={cboLoading}
                        />
                      </Form.Field>
                      <Form.Field style={{ flex: 1 }}></Form.Field>
                      <Form.Field
                        style={{
                          display: "flex",
                          alignItems: "end",
                        }}
                      >
                        <Button
                          id="ScannedDocument-Button-Search"
                          testid="btnSearch"
                          content={intl.formatMessage({ id: "ค้นหา" })}
                          color="blue"
                          fluid
                          onClick={handleSearchDocument}
                        />
                      </Form.Field>
                    </Form.Group>
                  )}

                  <Form.Group style={{ display: props.hideFilter ? "none" : "" }}>
                    <Form.Field className="--override-disabled --grey" width={6}>
                      <label>HN</label>
                      <PatientSearchBox
                        // @ts-ignore
                        id="ScannedDocument-PatientSearchBox-HN"
                        testid="sbxHN"
                        ref={hnRef}
                        patientList={patientList}
                        getNationality={getNationality}
                        getPatientList={getPatientList}
                        nationalitiesList={nationalitiesChoices}
                        patientListLoading={isLoading}
                        numberOfPage={numberOfHNPage}
                        currentPage={currentHNPage}
                        initialValue={props.patientInfo?.hn}
                        disabled
                        onPatientListPaginationChange={handlePaginationChange}
                        languageUX={props.languageUX}
                      />
                    </Form.Field>
                    <Form.Field width={6}>
                      <label>Encounter</label>
                      <SearchBox
                        id="ScannedDocument-SearchBox-Encounter"
                        ref={enRef}
                        testid="sbxEncounter"
                        onGetSearchOptions={getEncounterSearch}
                        defaultOptions={searchBoxOptions}
                        defaultId={defaultSearchBoxId}
                        defaultText={defaultSearchBoxText}
                        textField="number_date"
                      />
                    </Form.Field>
                    {!props.hideFilter && (
                      <Form.Field width={4}>
                        <label>&ensp;</label>
                        <Button
                          id="ScannedDocument-Button-Search"
                          testid="btnSearch"
                          content={intl.formatMessage({ id: "ค้นหา" })}
                          color="blue"
                          fluid
                          onClick={handleSearchDocument}
                        />
                      </Form.Field>
                    )}
                  </Form.Group>
                  <Form.Group style={{ ...(props.isViewDocumant && { display: "none" }) }}>
                    <Form.Field width={10}>
                      <label>{intl.formatMessage({ id: "ประเภทเอกสาร" })}</label>
                      <ComboBox
                        id="ScannedDocument-ComboBox-DocCategory"
                        testid="cboDocCategory"
                        ref={docCategoryRef}
                        fluid
                        clearable
                        placeholder="แสดงทุกประเภท"
                        options={documentCategoryOptions}
                        onChange={(e: any, { value }: any) => getDocumentType({ category: value })}
                        loading={cboLoading}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group style={{ ...(props.isViewDocumant && { display: "none" }) }}>
                    <Form.Field width={10}>
                      <label>{intl.formatMessage({ id: "ชื่อเอกสาร" })}</label>
                      <ComboBox
                        id="ScannedDocument-ComboBox-DocType"
                        testid="cboDocType"
                        ref={docTypeRef}
                        fluid
                        clearable
                        placeholder="แสดงทุกประเภท"
                        options={documentTypeOptions}
                        loading={cboLoading}
                      />
                    </Form.Field>
                    <Form.Field width={6}>
                      <label>{intl.formatMessage({ id: "เลขที่เอกสาร" })}</label>
                      <Input
                        id="ScannedDocument-Input-DocNo"
                        testid="txtDocNo"
                        value={docNumber}
                        onChange={(e) => setDocNumber(e.target.value)}
                      />
                    </Form.Field>
                  </Form.Group>
                  {!props.hideFilter && (
                    <Form.Group>
                      <Form.Field width={8}>
                        <label>{intl.formatMessage({ id: "แผนกที่สแกนเอกสาร" })}</label>
                        <ComboBox
                          id="ScannedDocument-ComboBox-ScanDiv"
                          testid="cboScanDiv"
                          ref={scanDivRef}
                          fluid
                          placeholder="แสดงทุกแผนกที่สแกน"
                          clearable
                          loading={cboLoading}
                          options={divisionOptions}
                        />
                      </Form.Field>
                      <Form.Field width={8}>
                        <label>{intl.formatMessage({ id: "ผู้สแกนเอกสาร" })}</label>
                        <SearchBox
                          id="ScannedDocument-SearchBox-Users"
                          ref={scanUserRef}
                          testid="sbxUsers"
                          onGetSearchOptions={getUsersSearch}
                          textField="full_name"
                        />
                      </Form.Field>
                    </Form.Group>
                  )}
                  {!props.hideFilter && (
                    <Form.Group>
                      <Form.Field width={8}>
                        <label>{intl.formatMessage({ id: "แผนกที่เจ้าของเอกสาร" })}</label>
                        <ComboBox
                          id="ScannedDocument-ComboBox-OwnerDiv"
                          testid="cboOwnerDiv"
                          ref={ownerDivRef}
                          fluid
                          placeholder="แสดงทุกแผนกที่สแกน"
                          // ref={ownerDivRef}
                          clearable
                          loading={cboLoading}
                          options={divisionOptions}
                        />
                      </Form.Field>
                      <Form.Field width={8}>
                        <label>{intl.formatMessage({ id: "แพทย์" })}</label>
                        <SearchBox
                          id="ScannedDocument-SearchBox-Doctor"
                          ref={doctorRef}
                          testid="sbxDoctor"
                          onGetSearchOptions={getDoctorSearch}
                          textField="name_code"
                        />
                      </Form.Field>
                    </Form.Group>
                  )}
                  {!props.hideFilter && (
                    <Form.Group inline>
                      <Form.Field
                        width={5}
                        label={intl.formatMessage({ id: "วันที่ของเอกสารสแกน" })}
                      />
                      <Form.Field width={5}>
                        <DateTextBox
                          id="ScannedDocument-DateTextBox-StartDoc"
                          testid="dtbStartDoc"
                          value={startDoc}
                          onChange={(date: any) => setStartDoc(date)}
                        />
                      </Form.Field>
                      <Form.Field width={1} label={intl.formatMessage({ id: "ถึง" })} />
                      <Form.Field width={5}>
                        <DateTextBox
                          id="ScannedDocument-DateTextBox-EndDoc"
                          testid="dtbEndDoc"
                          value={endDoc}
                          onChange={(date: any) => setEndDoc(date)}
                        />
                      </Form.Field>
                    </Form.Group>
                  )}
                  {!props.hideFilter && (
                    <Form.Group inline>
                      <Form.Field
                        width={5}
                        label={intl.formatMessage({ id: "วันที่สแกนเอกสาร" })}
                      />
                      <Form.Field width={5}>
                        <DateTextBox
                          id="ScannedDocument-DateTextBox-StartScan"
                          testid="dtbStartScan"
                          value={startScan}
                          onChange={(date: any) => setStartScan(date)}
                        />
                      </Form.Field>
                      <Form.Field width={1} label={intl.formatMessage({ id: "ถึง" })} />
                      <Form.Field width={5}>
                        <DateTextBox
                          id="ScannedDocument-DateTextBox-EndScan"
                          testid="dtbEndScan"
                          value={endScan}
                          onChange={(date: any) => setEndScan(date)}
                        />
                      </Form.Field>
                    </Form.Group>
                  )}
                  {!props.hideFilter && (
                    <Form.Group inline>
                      <Form.Field
                        width={5}
                        label={intl.formatMessage({ id: "วันที่หมดอายุของเอกสาร" })}
                      />
                      <Form.Field width={5}>
                        <DateTextBox
                          id="ScannedDocument-DateTextBox-StartExp"
                          testid="dtbStartExp"
                          value={startExp}
                          onChange={(date: any) => setStartExp(date)}
                        />
                      </Form.Field>
                      <Form.Field width={1} label={intl.formatMessage({ id: "ถึง" })} />
                      <Form.Field width={5}>
                        <DateTextBox
                          id="ScannedDocument-DateTextBox-EndExp"
                          testid="dtEndExp"
                          value={endExp}
                          onChange={(date: any) => setEndExp(date)}
                        />
                      </Form.Field>
                    </Form.Group>
                  )}
                  {props.hideFilter && !props.isViewDocumant && (
                    <Form.Group>
                      <Form.Field style={{ flex: 1 }}></Form.Field>
                      <Form.Field>
                        <Button
                          id="ScannedDocument-Button-Search"
                          testid="btnSearch"
                          content={intl.formatMessage({ id: "ค้นหา" })}
                          color="blue"
                          fluid
                          onClick={handleSearchDocument}
                        />
                      </Form.Field>
                    </Form.Group>
                  )}
                </Form>
                <PureReactTable
                  id="ScannedDocument-Table-Table"
                  testid="docTable"
                  className="--rt-tbody-overflow-y-hidden"
                  selectedClassName="blueSelectedRow"
                  showPagination={false}
                  showPageSizeOptions={false}
                  minRows={props.isViewDocumant ? scannedDocLimit > 4 ? scannedDocLimit : 4  : 4}
                  style={{ ...styles.docTable, ...(props.isViewDocumant && { height: "350px" }) }}
                  data={scannedDocList}
                  onSelect={(originalRow: any) => {
                    setSelectedRow(
                      props.isGrouped
                        ? {
                            ...originalRow?.items?.[0],
                            ...originalRow,
                            document_date: originalRow?.items?.[0]?.document_date,
                            document_type: originalRow?.items?.[0]?.document_type,
                          }
                        : originalRow
                    );
                    setImage(originalRow.document_image);
                  }}
                  selectedRow={selectedRow}
                  columns={
                    props.isViewDocumant
                      ? [
                          {
                            Header: "No.",
                            accessor: "no",
                            width: 50,
                            show: props.readOnly,
                            Cell: ({ original }: any = {}) => (
                              <>{props.isGrouped ? original.id : original?.no}</>
                            ),
                          },
                          {
                            Header: "วันที่เอกสาร",
                            accessor: "document_date",
                            Cell: ({ original }: any = {}) => (
                              <>
                                {props.isGrouped
                                  ? original?.items?.[0]?.document_date
                                  : original?.document_date}
                              </>
                            ),
                          },
                          {
                            Header: "ชื่อเอกสาร",
                            accessor: "document_type_name",
                            width: 300,
                            Cell: ({ original }: any = {}) => (
                              <>
                                {props.isGrouped
                                  ? original?.items[0].document_type_name ||
                                    original?.items[0].document_type_name_en
                                  : original?.document_type_name}
                              </>
                            ),
                          },
                          {
                            Header: "จำนวนหน้า",
                            accessor: "page",
                            Cell: ({ original }: any = {}) => (
                              <div style={{ display: "flex", justifyContent: "center" }}>
                                {original?.items?.reduce(
                                  (sum: number, item: any) => sum + item.page,
                                  0
                                ) || 0}
                              </div>
                            ),
                          },
                          {
                            Header: "พิมพ์",
                            accessor: "_print",
                            Cell: (row: any) => {
                              return alignCenter(
                                <Button
                                  color="orange"
                                  icon="print"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    handlePreparePrintURL(row.original);
                                  }}
                                />
                              );
                            },
                          },
                          {
                            Header: "ลบ",
                            accessor: "_delete",
                            Cell: (row: any) => {
                              return alignCenter(
                                <Button
                                  color="red"
                                  icon="minus"
                                  size="small"
                                  onClick={() => {
                                    setOpenModCancelAuthen(true);
                                  }}
                                />
                              );
                            },
                          },
                        ]
                      : [
                          {
                            Header: "no",
                            accessor: "no",
                            width: 50,
                            show: props.readOnly,
                            Cell: ({ original }: any = {}) => (
                              <>{props.isGrouped ? original.id : original?.no}</>
                            ),
                          },
                          {
                            Header: "",
                            accessor: "checked",
                            show: !props.readOnly,
                          },
                          {
                            Header: "วันที่เอกสาร",
                            accessor: "document_date",
                            Cell: ({ original }: any = {}) => (
                              <>
                                {props.isGrouped
                                  ? original?.items?.[0]?.document_date
                                  : original?.document_date}
                              </>
                            ),
                          },
                          {
                            Header: "หมายเลขเอกสาร",
                            accessor: "document_no",
                            show: !props.readOnly,
                          },
                          {
                            Header: "ประเภทเอกสาร",
                            accessor: "document_type_name",
                            width: 300,
                            Cell: ({ original }: any = {}) => (
                              <>
                                {props.isGrouped
                                  ? original?.items[0].document_type_name ||
                                    original?.items[0].document_type_name_en
                                  : original?.document_type_name}
                              </>
                            ),
                          },
                          {
                            Header: "การปกปิด",
                            accessor: "is_secret",
                            Cell: (row: any) => {
                              return alignCenter(
                                <Checkbox
                                  checked={
                                    props.isGrouped
                                      ? row.value ?? row.original?.items[0].is_secret
                                      : row.value
                                  }
                                  onChange={(e, { checked }) => {
                                    e.stopPropagation();
                                    handleCheckIsSecret({ row, checked });
                                  }}
                                />
                              );
                            },
                          },
                          {
                            Header: "พิมพ์",
                            accessor: "_print",
                            Cell: (row: any) => {
                              return alignCenter(
                                <Button
                                  color="teal"
                                  icon="print"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    handlePreparePrintURL(row.original);
                                  }}
                                />
                              );
                            },
                          },
                          {
                            Header: "แก้ไข",
                            accessor: "_edit",
                            minWidth: 50,
                            Cell: (row: any) => {
                              return alignCenter(
                                <Button
                                  color="yellow"
                                  icon="pencil"
                                  onClick={() => {
                                    setOpenModEditDoc(true);
                                  }}
                                />
                              );
                            },
                          },
                        ]
                  }
                />
                <br />
                <Form>
                  <Form.Group inline>
                    <Form.Field width={2}>
                      <ComboBox
                        options={pageOptions}
                        value={scannedDocLimit}
                        onChange={(e: any, { value }: any) => setScannedDocLimit(value)}
                      />
                    </Form.Field>
                    {generatePagination()}
                  </Form.Group>
                  <Form.Group
                    inline
                    className="rightAlign"
                    style={{ ...(props.isViewDocumant && { display: "none" }) }}
                  >
                    <Form.Field>
                      <Checkbox checked={checkedAll} onChange={handleCheckedAll} />
                    </Form.Field>
                    <Form.Field label={intl.formatMessage({ id: "ปกปิดเอกสาร" })} />
                    <Form.Field>
                      <Button
                        color="yellow"
                        content={intl.formatMessage({ id: "ปกปิดเอกสาร" })}
                        onClick={() => setOpenModSecretAuthen(true)}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid>
          </Container>
        </div>
      </CardLayout>
    </div>
  );
});
CardScannedDocument.displayName = "CardScannedDocument";

const pageOptions = [
  {
    key: 10,
    value: 10,
    text: 10,
  },
  {
    key: 20,
    value: 20,
    text: 20,
  },
  {
    key: 30,
    value: 30,
    text: 30,
  },
  {
    key: 40,
    value: 40,
    text: 40,
  },
  {
    key: 50,
    value: 50,
    text: 50,
  },
  {
    key: 100,
    value: 100,
    text: 100,
  },
];

const styles = {
  docTable: {
    height: "250px",
  },
  segment: {
    height: "100%",
    overflowY: "auto",
    display: "flex",
    justifyContent: "center",
  },
  image: { cursor: "zoom-in", height: "500px" },
};

export default React.memo(CardScannedDocument);
